import React, { useState } from 'react';
import Button from '@/components/Button';
import { newsContent as importedNewsContent } from '@/data/news';
import ContactForm from '@/components/ContactForm';
import AnnouncementSection from '@/components/sections/AnnouncementSection';
import { HeroBanner } from '@/components/sections/HeroBanner';
import JoinUsSection from '@/components/sections/JoinUsSection';
import InformationCarousel from '@/components/sections/InformationCarousel';
import NewsModal from '@/components/modals/NewsModal';
import SimpleModal from '@/components/modals/SimpleModal';
import SellosContentModal from '@/components/modals/SellosContentModal';
import ListContentModal from '@/components/modals/ListContentModal';

// --- Textos para Modales ---
const newsContent = importedNewsContent;

const selloFamiliaText = `Con un enfoque altamente familiar, como escuela somos partícipes del aprendizaje de nuestros niños y niñas, entendiendo que la educación primordial y principal viene desde el hogar, por lo que nuestra labor de enseñanza-aprendizaje se sustenta en el apoyo y entrega de herramientas y conocimientos tanto hacia nuestros alumnos, como a la familia que los guía en este proceso.`;
const selloAmorText = `Nuestro equipo trabaja con orgullo sobre cada uno de los logros y pasos de nuestros alumnos, entregando amor y dedicación cada día, para que nuestros niños y niñas, como la familia, puedan sentir la acogida de ser partícipes de esta institución.`;
const selloHuellaText = `El significado de este concepto ha sido atribuido gracias a nuestros alumnos egresados y sus familias, los cuales lo han manifestado a raíz de la dedicación, entrega, compromiso y alegría que como equipo plasmamos día a día en cada familia y niño como institución educativa, lo cual implica que no solamente brindemos un proceso de enseñanza aprendizaje basado en la entrega de conocimientos y formación, sino que sea un proceso integral sustentado en un ambiente óptimo.`;

// Lista para Modal de Servicios y Beneficios
const serviciosBeneficiosList = [
  "Buzo escolar gratuito por primera vez que se realice matrícula.",
  "Beca de útiles escolares 2026.",
  "Taller de yoga infantil para todos nuestros niveles.",
  "Convenio con Colegio Nuevo Milenio para nuestros egresados de Kínder (matrícula gratis y descuento del 50% de mensualidad).",
  "Agenda de comunicaciones digital \"Notasnet\"."
];

const calendarioPlaceholderText = "Aquí encontrarás las fechas importantes y actividades programadas para el año escolar. Este contenido será actualizado próximamente.";

export default function Home() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [modalType, setModalType] = useState(null);


  const openModal = (type) => {
    let content = null;
    let newsModalFlag = false;
    let specificModalType = type;

    switch (type) {
      case "news":
        content = newsContent;
        newsModalFlag = true;
        break;
      case "servicios":
        content = { 
          title: "Nuestros Servicios y Beneficios", 
          items: serviciosBeneficiosList
        };
        specificModalType = 'list';
        break;
      case "calendario":
        content = { title: "Calendario Escolar", text: calendarioPlaceholderText };
        specificModalType = 'simple';
        break;
      case "sellos":
        content = { 
          title: "Nuestros Sellos Educativos", 
          selloFamilia: selloFamiliaText,
          selloAmor: selloAmorText,
          selloHuella: selloHuellaText
        };
        break;
      default:
        content = { title: "Información", text: "Este es un cuadro de texto simple." };
        specificModalType = 'simple';
        break;
    }
    
    setModalContent(content);
    setModalType(newsModalFlag ? 'news' : specificModalType);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalType(null);
  };

  return (
    <main className="flex-1 w-full flex flex-col items-center">
      <HeroBanner 
        title="Bienvenidos a Escuela de Lenguaje Arcoíris"
        subtitle="Formando líderes para el futuro con educación gratuita y de calidad con valores sólidos."
        backgroundImageUrl="/images/gallery/foto1.jpg"
      >
         <Button href="/proceso-admision" variant="default">
            Proceso de Admisión
          </Button>
          <ContactForm variant="outline" />
      </HeroBanner>

      <AnnouncementSection />
      <InformationCarousel openModal={openModal} />
      <JoinUsSection />
      
      {isModalOpen && (
        modalType === 'news' ? (
          <NewsModal news={modalContent} onClose={closeModal} />
        ) : modalType === 'simple' ? (
          <SimpleModal content={modalContent} onClose={closeModal} />
        ) : modalType === 'sellos' ? (
          <SellosContentModal content={modalContent} onClose={closeModal} />
        ) : modalType === 'list' ? (
          <ListContentModal content={modalContent} onClose={closeModal} />
        ) : null
      )}
    </main>
  );
}
